"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var SubModule_1 = require("./SubModule");

var types_1 = require("../../types");

var procedures_1 = require("../../procedures");

var Checkpoint_1 = require("../Checkpoint");

var PolymathError_1 = require("../../PolymathError");

var DividendDistribution_1 = require("../DividendDistribution");

var TaxWithholding_1 = require("../TaxWithholding");
/**
 * Namespace that handles all Dividend related functionality
 */


var Dividends =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Dividends, _SubModule_1$SubModul);

  function Dividends() {
    var _this;

    _classCallCheck(this, Dividends);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dividends).apply(this, arguments));
    /**
     * Distribute dividends in POLY
     *
     * @param args.checkpointId - uuid of the checkpoint to use as reference for the distribution
     * @param args.maturityDate - date from which dividends can be paid/collected
     * @param args.expiryDate - date up to which dividends can be paid/collected
     * @param args.amount - amount to be distributed
     * @param args.name - human readable name of the distribution
     * @param args.excludedAddresses - tokenholder addresses that will be excluded from the distribution (optional)
     * @param args.taxWithholdings - array that specifies how much to withhold from each tokenholder for tax purposes
     */

    _this.createPolyDistribution = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var context, securityToken, polyAddress, checkpointId, rest, symbol, _Checkpoint_1$Checkpo, checkpointIndex, procedure;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                _context.next = 3;
                return context.contractWrappers.polyToken.address();

              case 3:
                polyAddress = _context.sent;
                checkpointId = args.checkpointId, rest = __rest(args, ["checkpointId"]);
                symbol = securityToken.symbol;
                _Checkpoint_1$Checkpo = Checkpoint_1.Checkpoint.unserialize(checkpointId), checkpointIndex = _Checkpoint_1$Checkpo.index;
                procedure = new procedures_1.CreateDividendDistribution(Object.assign({
                  erc20Address: polyAddress,
                  symbol: symbol,
                  checkpointIndex: checkpointIndex
                }, rest), context);
                return _context.abrupt("return", procedure.prepare());

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Distribute dividends in a specified ERC20 token
     *
     * @param args.checkpointId - uuid of the checkpoint to use as reference for the distribution
     * @param args.maturityDate - date from which dividends can be paid/collected
     * @param args.expiryDate - date up to which dividends can be paid/collected
     * @param args.erc20Address - address of the ERC20 token that will be used as currency
     * @param args.amount - amount to be distributed
     * @param args.name - human readable name of the distribution
     * @param args.excludedAddresses - tokenholder addresses that will be excluded from the distribution (optional)
     * @param args.taxWithholdings - array that specifies how much to withhold from each tokenholder for tax purposes
     */


    _this.createErc20Distribution = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var context, securityToken, checkpointId, rest, symbol, _Checkpoint_1$Checkpo2, checkpointIndex, procedure;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                checkpointId = args.checkpointId, rest = __rest(args, ["checkpointId"]);
                symbol = securityToken.symbol;
                _Checkpoint_1$Checkpo2 = Checkpoint_1.Checkpoint.unserialize(checkpointId), checkpointIndex = _Checkpoint_1$Checkpo2.index;
                procedure = new procedures_1.CreateDividendDistribution(Object.assign({
                  symbol: symbol,
                  checkpointIndex: checkpointIndex
                }, rest), context);
                return _context2.abrupt("return", procedure.prepare());

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Set default tax withtholding list for a type of dividends
     *
     * @param args.taxWithholdings - array that specifies how much to withhold from each tokenholder for tax purposes
     */


    _this.modifyTaxWithholdingList = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var taxWithholdings, rest, symbol, tokenholderAddresses, percentages, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                taxWithholdings = args.taxWithholdings, rest = __rest(args, ["taxWithholdings"]);
                symbol = this.securityToken.symbol;
                tokenholderAddresses = [];
                percentages = [];
                taxWithholdings.forEach(function (_ref) {
                  var address = _ref.address,
                      percentage = _ref.percentage;
                  tokenholderAddresses.push(address);
                  percentages.push(percentage);
                });
                procedure = new procedures_1.UpdateDividendsTaxWithholdingList(Object.assign({
                  symbol: symbol,
                  tokenholderAddresses: tokenholderAddresses,
                  percentages: percentages
                }, rest), this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Change dividends storage wallet address
     *
     * @param args.address - new storage wallet address
     */


    _this.modifyStorageWallet = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.SetDividendsWallet(Object.assign({
                  symbol: symbol
                }, args), this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };
    /**
     * Set default exclusion list for a type of dividends. Addresses on this list won't be considered for dividend distribution. This operation overrides the previous default exclusion list
     *
     * @param args.tokenholderAddresses - array of tokenholder addresses to be excluded from dividends
     */


    _this.modifyDefaultExclusionList = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var tokenholderAddresses, rest, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tokenholderAddresses = args.tokenholderAddresses, rest = __rest(args, ["tokenholderAddresses"]);
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.ModifyDividendsDefaultExclusionList(Object.assign({
                  symbol: symbol,
                  tokenholderAddresses: tokenholderAddresses
                }, rest), this.context);
                return _context5.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
    /**
     * Retrieve a list of investor addresses and their corresponding tax withholding percentages
     */


    _this.getTaxWithholdingList = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this$context, _this$context$contrac, tokenFactory, getAttachedModules, factories, _this$securityToken, symbol, securityTokenId, securityToken, _ref2, _ref3, dividendsModule, checkpointIndex, checkpointData;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$context = this.context, _this$context$contrac = _this$context.contractWrappers, tokenFactory = _this$context$contrac.tokenFactory, getAttachedModules = _this$context$contrac.getAttachedModules, factories = _this$context.factories;
                _this$securityToken = this.securityToken, symbol = _this$securityToken.symbol, securityTokenId = _this$securityToken.uid;
                _context6.prev = 2;
                _context6.next = 5;
                return tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context6.sent;
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context6.next = 13;
                return getAttachedModules({
                  symbol: symbol,
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint
                }, {
                  unarchived: true
                });

              case 13:
                _ref2 = _context6.sent;
                _ref3 = _slicedToArray(_ref2, 1);
                dividendsModule = _ref3[0];

                if (dividendsModule) {
                  _context6.next = 18;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "The Dividends Feature hasn't been enabled"
                });

              case 18:
                _context6.next = 20;
                return securityToken.currentCheckpointId();

              case 20:
                checkpointIndex = _context6.sent;
                _context6.next = 23;
                return dividendsModule.getCheckpointData({
                  checkpointId: checkpointIndex.toNumber()
                });

              case 23:
                checkpointData = _context6.sent;
                return _context6.abrupt("return", checkpointData.map(function (_ref4) {
                  var investor = _ref4.investor,
                      withheld = _ref4.withheld;
                  return factories.taxWithholdingFactory.create(TaxWithholding_1.TaxWithholding.generateId({
                    tokenholderAddress: investor,
                    securityTokenId: securityTokenId
                  }), {
                    percentage: withheld.toNumber(),
                    securityTokenSymbol: symbol
                  });
                }));

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));
    };
    /**
     * Retrieve all dividend distributions at a certain checkpoint
     */


    _this.getDistributions = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this$context2, contractWrappers, factories, checkpointId, _this$securityToken2, symbol, securityTokenId, _Checkpoint_1$Checkpo3, checkpointIndex, checkpointDividends, dividends;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this$context2 = this.context, contractWrappers = _this$context2.contractWrappers, factories = _this$context2.factories;
                checkpointId = args.checkpointId;
                _this$securityToken2 = this.securityToken, symbol = _this$securityToken2.symbol, securityTokenId = _this$securityToken2.uid;
                _Checkpoint_1$Checkpo3 = Checkpoint_1.Checkpoint.unserialize(checkpointId), checkpointIndex = _Checkpoint_1$Checkpo3.index;
                _context7.next = 6;
                return contractWrappers.getAllDividends({
                  securityTokenSymbol: symbol,
                  checkpointId: checkpointIndex
                });

              case 6:
                checkpointDividends = _context7.sent;
                dividends = checkpointDividends.map(function (_a) {
                  var index = _a.index,
                      dividend = __rest(_a, ["index"]);

                  return factories.dividendDistributionFactory.create(DividendDistribution_1.DividendDistribution.generateId({
                    securityTokenId: securityTokenId,
                    index: index
                  }), Object.assign({}, dividend, {
                    checkpointId: checkpointId,
                    securityTokenSymbol: symbol
                  }));
                });
                return _context7.abrupt("return", dividends);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    };
    /**
     * Retrieve a particular dividend distribution by type and index or UUID
     *
     * @param args - dividend uuid or object containing its index
     */


    _this.getDistribution = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var dividendIndex, uid, securityTokenId;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // fetch by UUID
                if (typeof args === 'string') {
                  uid = args;
                } else {
                  dividendIndex = args.dividendIndex;
                  securityTokenId = this.securityToken.uid;
                  uid = DividendDistribution_1.DividendDistribution.generateId({
                    securityTokenId: securityTokenId,
                    index: dividendIndex
                  });
                }

                return _context8.abrupt("return", this.context.factories.dividendDistributionFactory.fetch(uid));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    };
    /**
     * Retrieve the list of addresses which are excluded from receiving dividend payments by default
     */


    _this.getDefaultExclusionList = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this$context$contrac2, tokenFactory, getAttachedModules, symbol, _ref5, _ref6, dividendsModule;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this$context$contrac2 = this.context.contractWrappers, tokenFactory = _this$context$contrac2.tokenFactory, getAttachedModules = _this$context$contrac2.getAttachedModules;
                symbol = this.securityToken.symbol;
                _context9.prev = 2;
                _context9.next = 5;
                return tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                _context9.next = 10;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                _context9.next = 12;
                return getAttachedModules({
                  symbol: symbol,
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint
                }, {
                  unarchived: true
                });

              case 12:
                _ref5 = _context9.sent;
                _ref6 = _slicedToArray(_ref5, 1);
                dividendsModule = _ref6[0];

                if (dividendsModule) {
                  _context9.next = 17;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "The Dividends Feature hasn't been enabled"
                });

              case 17:
                return _context9.abrupt("return", dividendsModule.getDefaultExcluded());

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 7]]);
      }));
    };

    return _this;
  }

  return Dividends;
}(SubModule_1.SubModule);

exports.Dividends = Dividends;